export default __webpack_public_path__ + "double-left-chevron.png";